import { apiService } from './api'

export interface DashboardOverview {
  total_tenants: number
  total_users: number
  active_projects: number
  /**
   * ADM-2.1. `null` means "we cannot tell you yet", NOT zero.
   *
   * This was `total_tenants * 500` on the server, captioned as an estimate. The
   * caption disclosed it; the card still rendered a formatted currency figure as
   * its headline, which is where a reader takes the number from. It is null until
   * billing carries rows: all five `billing_*` tables are live and empty, and
   * BILL-1.7 (provider secrets and webhook URLs) is still open. The real figure
   * arrives with ADM-2.2.
   */
  monthly_revenue: number | null
  /** Why `monthly_revenue` is null, rendered verbatim so the card explains itself. */
  monthly_revenue_unavailable_reason?: string
}

export const dashboardService = {
  /**
   * Get dashboard overview metrics
   */
  async getOverview(): Promise<DashboardOverview> {
    const response = await apiService.get<DashboardOverview>('/analytics/overview/')
    return response
  },
}